import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import GroupedDropdown from './GroupedDropdown';

const ChannelGroupsDropdown = ({
  channels,
  selectedChannelId,
  onSelect,
  ...props
}) => {
  const channelGroups = useMemo(() => {
    let obj = {
      'Broadcasts': [],
      'Public Channels': [],
      'Private Channels': [],
      'Direct Messages': []
    };

    channels.forEach(channel => {
      const { id, name, directMessage, private: isPrivate, broadcastType } = channel;
      const reactComponent = <option key={id} value={channel.id}>{name}</option>;

      if (directMessage) {
        obj['Direct Messages'].push(reactComponent);
      } else if (isPrivate) {
        obj['Private Channels'].push(reactComponent);
      } else if (broadcastType) {
        obj['Broadcasts'].push(reactComponent);
      } else {
        obj['Public Channels'].push(reactComponent);
      }
    });

    return obj;
  }, [channels]);

  return (
    <GroupedDropdown
      groups={channelGroups}
      label='Channel'
      selected={selectedChannelId}
      onSelect={onSelect}
    />
  );
};

ChannelGroupsDropdown.propTypes = {
  channels: PropTypes.array,
  selectedChannelId: PropTypes.string,
  onSelect: PropTypes.func
};

export default ChannelGroupsDropdown;
